import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sequence-overview-aside-label",
  "use": "icon-sequence-overview-aside-label-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" fill=\"none\" id=\"icon-sequence-overview-aside-label\">\n    <path d=\"M2.54102 11.6V4.4C2.54102 4.17909 2.7201 4 2.94102 4H11.6603C11.794 4 11.9189 4.06684 11.9931 4.17812L14.3931 7.77813C14.4827 7.91247 14.4827 8.08753 14.3931 8.22187L11.9931 11.8219C11.9189 11.9331 11.794 12 11.6603 12H2.94102C2.7201 12 2.54102 11.8209 2.54102 11.6Z\" stroke-width=\"1.06667\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol